export class CanvasBackgroundMedia {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  dpr = window.devicePixelRatio || 1;
  mediaElement?: HTMLImageElement | HTMLVideoElement;
  useRaf?: boolean;

  constructor(canvasElement: HTMLCanvasElement, useRaf?: boolean) {
    this.canvas = canvasElement;
    this.ctx = this.canvas.getContext("2d")!;
    this.useRaf = useRaf;

    const resizeObserver = new ResizeObserver(this.resizeCanvas);

    resizeObserver.observe(this.canvas);

    if (this.useRaf) {
      requestAnimationFrame(this.rafUpdate);
    }
  }

  resizeCanvas = () => {
    this.ctx.canvas.width = this.canvas.clientWidth * this.dpr;
    this.ctx.canvas.height = this.canvas.clientHeight * this.dpr;

    if (this.mediaElement && !this.useRaf) {
      this.drawElement(this.mediaElement);
    }
  };

  setElement = (mediaElement: HTMLImageElement | HTMLVideoElement) => {
    this.mediaElement = mediaElement;

    if (!this.useRaf) {
      this.drawElement(mediaElement);
    }
  };

  drawElement = (mediaElement: HTMLImageElement | HTMLVideoElement) => {
    const elementWidth =
      mediaElement instanceof HTMLVideoElement
        ? mediaElement.videoWidth
        : mediaElement.naturalWidth;

    const elementHeight =
      mediaElement instanceof HTMLVideoElement
        ? mediaElement.videoHeight
        : mediaElement.naturalHeight;

    const canvasRatio = this.ctx.canvas.width / this.ctx.canvas.height;
    const mediaRatio = elementWidth / elementHeight;
    let drawWidth, drawHeight, offsetX, offsetY;

    if (mediaRatio > canvasRatio) {
      // wider — crop left/right
      drawHeight = this.ctx.canvas.height;
      drawWidth = elementWidth * (this.ctx.canvas.height / elementHeight);
      offsetX = (this.ctx.canvas.width - drawWidth) / 2;
      offsetY = 0;
    } else {
      // taller — crop top/bottom
      drawWidth = this.ctx.canvas.width;
      drawHeight = elementHeight * (this.ctx.canvas.width / elementWidth);
      offsetX = 0;
      offsetY = (this.ctx.canvas.height - drawHeight) / 2;
    }

    this.ctx.drawImage(mediaElement, offsetX, offsetY, drawWidth, drawHeight);
  };

  clear = () => {
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  };

  rafUpdate = () => {
    if (this.mediaElement) {
      this.drawElement(this.mediaElement);
    }

    if (this.useRaf) {
      requestAnimationFrame(this.rafUpdate);
    }
  };
}
